import { render } from "./AtmosphereSection.vue?vue&type=template&id=81d36cf6&scoped=true"
import script from "./AtmosphereSection.vue?vue&type=script&lang=js"
export * from "./AtmosphereSection.vue?vue&type=script&lang=js"

import "./AtmosphereSection.vue?vue&type=style&index=0&id=81d36cf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d36cf6"]])

export default __exports__